import { useCallback, useState } from 'react'

const defaultInitialLines = [{ id: 0 }]
const useMultipleLineForm = (initialLines = undefined) => {
  const [lines, setLines] = useState<Record<string, any>[]>(initialLines || defaultInitialLines)
  const [errors, setErrors] = useState([{}])

  const addNewLine = useCallback(() => {
    setLines(prevState => [...prevState, { id: prevState?.length > 0 ? (prevState[prevState.length - 1]?.id + 1) : 0 }])
    setErrors(prevState => [...prevState, {}])
  }, [])

  const removeLine = (id) => {
    setLines(prevState => [...prevState].filter((x) => x.id !== id))
    // setErrors(prevState => [...prevState].filter((x) => x?.id !== id))
  }

  const onFormChange = useCallback((index, data) => {
    setLines((prevState) => [
      ...prevState.map(
        (item, i) => (item?.id === index ? { ...item, ...data } : item)
      )
    ])
  }, [])

  const setLineErrors = useCallback((index, errors) => {
    setErrors((prevState) => prevState.map((item, i) => (i === index ? { ...item, errors } : item)))
  }, [])

  const resetLines = () => {
    setLines([{ id: 0 }])
  }

  return { addNewLine, setLines, removeLine, onFormChange, setErrors: setLineErrors, errors, lines, resetLines }
}

export default useMultipleLineForm
